<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-06-08 15:18:13
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="visible"
      :title="title"
      :visible.sync="visible"
      width="50%"
      @close="close"
    >
      <el-form
        :model="form"
        ref="form"
        :rules="validatorRules"
        label-width="120px"
        :inline="false"
        size="normal"
        :disabled="formDisabled"
      >
        <el-form-item label="通知名称" prop="noticeName">
          <el-input
            v-model.trim="form.noticeName"
            placeholder="请输入商品名称"
            maxlength="50"
            style="width: 90%"
          ></el-input>
        </el-form-item>

        <el-form-item label="开始时间" prop="startTime">
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="选择日期时间"
            default-time="00:00:00"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="选择日期时间"
            default-time="19:00:00"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否展示" prop="isShow">
          <el-radio-group v-model="form.isShow">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="通知图片" prop="noticePic">
          <el-upload
            :class="form.noticePic ? 'hide' : 'show'"
            action
            ref="staffImgUpload"
            :file-list="fileList"
            :limit="1"
            :on-exceed="surpass"
            list-type="picture-card"
            :http-request="importFile"
            :on-remove="noticePicImageRemove"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePictureCardPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>

      <span slot="footer" v-if="!formDisabled">
        <el-button @click="visible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="handleOk" size="mini">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
  </div>
</template>

<script>
import { httpAction, uploadAction } from "@/api/manage";

import { listMixin } from "@/mixins/listMixin";
import { convertTime } from "@/utils/util";

var validateInput = (rule, value, callback) => {
  if (value === "") {
    callback(new Error("请输入名称"));
  }
  let newValue = value.replace(/[<>/\\]/g, "");
  if (newValue !== value) {
    callback(new Error("请勿输入特殊字符"));
  } else {
    callback();
  }
};
export default {
  components: {},
  mixins: [listMixin],
  props: {},
  data() {
    return {
      formDisabled: false,
      disableMixinCreated: true,
      title: "操作",
      visible: false,
      confirmLoading: false,
      form: { startTime: '', endTime: ''},
      validatorRules: {
        noticeName: [
          { required: true, message: "请输入通知名称", trigger: "blur" },
          { max: 50, message: "长度在 50 个字符以内", trigger: "change" },
          {
            validator: validateInput,
            message: "不可以输入特殊符号",
            trigger: "blur",
          },
        ],
        startTime: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        endTime: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        isShow: [{ required: true, message: "请选择是否展示", trigger: "change" }],
        noticePic: [
          { required: true, message: "请上传通知图片", trigger: "change" },
        ],
      },
      url: {
        add: "/wlIndexNotice/add",
        edit: "/wlIndexNotice/edit",
        upload: "/api/upload",
        detail: "/wlIndexNotice/detail",
      },
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    bindClass(num, name) {
      if (num <= this.form[name]?.length) return "hide";
      else if (this.formDisabled) return "hide";
      else return "show";
    },
    beforeAvatarUpload(file) {
      let types = ["image/jpeg", "image/jpg", "image/bmp", "image/png"];
      const isIMG = types.includes(file.type);
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isIMG) {
        this.$message.error("上传图片只能是 JPG、JPEG、bmp、PNG 格式!");
      }
      if (!isLt10M) {
        this.$message.error("上传头像图片大小不能超过 10MB!");
      }
      return isIMG && isLt10M;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    importFile(file) {
      let formData = new FormData();
      formData.append("businessType", 180);
      formData.append("file", file.file, file.file.name); // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传即可
      uploadAction(this.url.upload, formData)
        .then((res) => {
          this.$message.success("上传成功");
          this.form.noticePic = res.data[0];
          this.$refs["form"].clearValidate("noticePic");
        })
        .catch((err) => {
          this.$message.error("上传失败");
        });
    },
    noticePicImageRemove() {
      this.form.noticePic = "";
    },
    surpass() {
      this.$message.warning("图片超过限定张数!");
    },
    add() {
      this.edit();
    },
    edit(record, type) {
      this.formDisabled = type;
      record &&
        httpAction(this.url.detail + '?id=' + record.id, {}, "post").then((res) => {
          if (res.code === 200) {
            res.data.startTime = res.data.startTime ? new Date(res.data.startTime) : null;
            res.data.endTime = res.data.endTime ? new Date(res.data.endTime) : null;
            this.form = res.data;
            this.$refs["form"].clearValidate("noticePic");
            this.fileList.push({ uid: 0, url: res.data.noticePic || "" });
          }
        });
      this.visible = true;
    },
    close() {
      this.$refs.form.resetFields();
      this.fileList = [];
      this.$emit("close");
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          const timeReg = /^(\d{4})/;
          let startTime = ''
          let endTime = ''
          if (this.form.startTime ? !timeReg.test(this.form.startTime) : "")
            startTime = convertTime(this.form.startTime);
          if (this.form.endTime ? !timeReg.test(this.form.endTime) : "")
            endTime = convertTime(this.form.endTime);
          this.$refs["form"].clearValidate("noticePic");
          that.confirmLoading = true;
          let httpurl = "";
          let method = "";
          const parms = { ...this.form, startTime, endTime};
          if (!this.form.id) {
            httpurl += this.url.add;
            method = "post";
          } else {
            httpurl += this.url.edit;
            method = "post"; //put
            parms.userId = this.form.id;
          }
          httpAction(httpurl, parms, method)
            .then((res) => {
              if (res.code == 200) {
                that.$message.success("操作成功");
                that.$emit("ok");
              } else {
                that.$message.warning(res.msg);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="less" scoped>
.wrapper {
}
.formDiv {
  margin-left: 40px;
  margin-bottom: 22px;
  span {
    width: 80px;
    line-height: 36px;
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    font-weight: 700;
    color: #606266;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    cursor: default;
  }
}
.hide /deep/ .el-upload--picture-card {
  display: none;
}
.show /deep/ .el-upload--picture-card {
  display: block;
}
</style>
